import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyStateWithIllustration = ({
  children
}) => {
  return /*#__PURE__*/_jsx(ResultsMessage, {
    illustration: "empty-state-charts",
    illustrationProps: {
      width: 72,
      role: 'img',
      marginBlockEnd: '200'
    },
    "data-selenium-test": "associated-objects-card-empty-state",
    "data-test-id": "associated-objects-card-empty-state",
    marginBlock: "0",
    children: children
  });
};
export default EmptyStateWithIllustration;